<template>
  <div class="bg_color">
    <top-header
      :type="6"
      :placeholder="'活动流程'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <img src="@/assets/img/strictSelection/liucheng.jpg" alt="" />
  </div>
</template>

<script>
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import qs from "qs";
export default {
  data() {
    return {
      textColor: "#fff",
      bgColor: "transparent",
    };
  },
  components: {
    topHeader,
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.bg_color {
  background-color: #f6f6f6;
  img {
    width: 100%;
  }
}
</style>
